<template>
  <div class="org-tree-panel" :class="{'multiple':multiple}">
    <div class="input-box" v-if="!isSelect">
      <Input v-model="keyword" placeholder="请输入关键字或code搜索" @input="keyword==''&&(isSearch=false)" @on-enter="search"/>
      <Icon type="ios-search" @click="search"/>
    </div>
    <search-result ref="searchBox" :source="source" v-if="keyword&&isSearch" @selectChange="selectChange"></search-result>
    <Tree v-else :data="treeData" :render="renderContent" @on-select-change="selectChange" :check-strictly="true"
      :show-checkbox="multiple" @on-check-change="checkChange"></Tree>
  </div>
</template>

<script>
import searchResult from "./searchResult";
export default {
  components: {searchResult},
  props: {
    value:null,//当前选中
    source:null,//1所有，2排除渠道
    multiple:null,//是否显示多选框
    isSelect:null,//是否是下拉选择组件中
    isAll:{//顶级是否可选
      default:true
    },
  },
  data() {
    return {
      ajaxUrl: '',
      params: null,
      keyword: '',
      isSearch:false,
      treeData: [],
    }
  },
  watch: {
    value:{
      handler(){
        this.foreachTree(this.treeData, this.value);
      },
      deep:true,
    }
  },
  computed: {},
  created() {},
  mounted() {
    if(this.isSelect){
      return;
    }
    if(this.$route.query.type==1){//机构
      this.getTreeData(this.$route.query.organizationId)
    }else if(this.$route.query.type==2){//团队
      this.getTreeData(this.$route.query.groupId)
    }else{
      this.getTreeData()
    }
  },
  methods: {
    init(ajaxUrl, params){
      if(this.treeData.length){
        return;
      }
      this.ajaxUrl = ajaxUrl||'';
      this.params = params||null;//此参数传了source就无效
      this.getTreeData()
    },
    search(){
      if(!this.keyword){
        return;
      }
      this.isSearch = true;
      this.$nextTick(()=>{
        this.$refs.searchBox.search(this.keyword)
      })
    },
    getTreeData(id) {
      this.search();
      const ajaxUrl = this.ajaxUrl||'/buz/organizationBase/read/tree';
      const params = this.params||{source:this.source};
      this.$http({
        url: ajaxUrl,
        type: 'post',
        data: params,
      }).then((res) => {
        res.data.isTop = true;
        if(!this.isAll){
          res.data.disabled = true;
        }
        if(this.isSelect){
          this.treeData = this.foreachTree([res.data], this.value)
        }else {
          this.treeData = this.foreachTree([res.data], [id])
          if(!id) {
            res.data.selected = true;
            this.$emit("change",res.data);
          }
        }
      })
    },
    foreachTree(treeData, ids=[]) {
      treeData.forEach(item=>{
        item.expand = true;
        if(ids.includes(item.id)){
          this.$set(item,'selected',true);
          this.$set(item,'checked',true);
          if(!this.isSelect){
            this.$emit("change",item);
          }
        }else{
          this.$set(item,'selected',false);
          this.$set(item,'checked',false);
        }
        if(item.children&&item.children.length){
          this.foreachTree(item.children, ids)
        }
      })
      return treeData
    },
    renderContent(h, { root, node, data }) {
      let hasChild = data.children&&data.children.length?'has-child':''
      let renderIcon = '';
      if(!data.isTop){
        if(data.orgType==2){
          renderIcon = (<span class={`tree-icon ${hasChild}`}>省</span>);
        }else if(data.orgType==3){
          renderIcon = (<span class={`tree-icon org ${hasChild}`}>市</span>);
        }else if(data.orgType==4){
          renderIcon = (<span class={`tree-icon blue ${hasChild}`}>区</span>);
        }else if(data.orgType==5){
          renderIcon = (<span class={`tree-icon green ${hasChild}`}>渠</span>);
        }
      }
      
      let name = '';
      if(data.code){
        name = data.name+'-'+data.code
      }else{
        name = data.name
      }
      let dian = '';
      if(data.orgType){
        dian = (<span class={data.status==2?'dian red':'dian green'}></span>);
      }
      return (
        <div class="tree-item">
          {dian}
          {renderIcon}
          <span class={`org-name ${data.isTop?'isTop':''}`}>{name}</span>
        </div>
      )
    },
    checkChange(arr,data){
      this.$emit("change",data,arr);
    },
    selectChange(arr,data){
      if(!this.multiple) {
        this.$emit("change",data,arr);
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import './orgTree.scss';
</style>